"use strict";

var _slicedToArray = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/toConsumableArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var punycode = require("punycode");
var regexes = require("./lib/regexes.js");
var mappingTable = require("./lib/mappingTable.json");
function containsNonASCII(str) {
  return /[^\x00-\x7F]/.test(str);
}
function findStatus(val, _ref) {
  var useSTD3ASCIIRules = _ref.useSTD3ASCIIRules;
  var start = 0;
  var end = mappingTable.length - 1;
  while (start <= end) {
    var mid = Math.floor((start + end) / 2);
    var target = mappingTable[mid];
    if (target[0][0] <= val && target[0][1] >= val) {
      if (target[1].startsWith("disallowed_STD3_")) {
        var newStatus = useSTD3ASCIIRules ? "disallowed" : target[1].slice(16);
        return [newStatus].concat(_toConsumableArray(target.slice(2)));
      }
      return target.slice(1);
    } else if (target[0][0] > val) {
      end = mid - 1;
    } else {
      start = mid + 1;
    }
  }
  return null;
}
function mapChars(domainName, _ref2) {
  var useSTD3ASCIIRules = _ref2.useSTD3ASCIIRules,
    processingOption = _ref2.processingOption;
  var hasError = false;
  var processed = "";
  var _iterator = _createForOfIteratorHelper(domainName),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ch = _step.value;
      var _findStatus = findStatus(ch.codePointAt(0), {
          useSTD3ASCIIRules: useSTD3ASCIIRules
        }),
        _findStatus2 = _slicedToArray(_findStatus, 2),
        status = _findStatus2[0],
        mapping = _findStatus2[1];
      switch (status) {
        case "disallowed":
          hasError = true;
          processed += ch;
          break;
        case "ignored":
          break;
        case "mapped":
          processed += mapping;
          break;
        case "deviation":
          if (processingOption === "transitional") {
            processed += mapping;
          } else {
            processed += ch;
          }
          break;
        case "valid":
          processed += ch;
          break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    string: processed,
    error: hasError
  };
}
function validateLabel(label, _ref3) {
  var checkHyphens = _ref3.checkHyphens,
    checkBidi = _ref3.checkBidi,
    checkJoiners = _ref3.checkJoiners,
    processingOption = _ref3.processingOption,
    useSTD3ASCIIRules = _ref3.useSTD3ASCIIRules;
  if (label.normalize("NFC") !== label) {
    return false;
  }
  var codePoints = Array.from(label);
  if (checkHyphens) {
    if (codePoints[2] === "-" && codePoints[3] === "-" || label.startsWith("-") || label.endsWith("-")) {
      return false;
    }
  }
  if (label.includes(".") || codePoints.length > 0 && regexes.combiningMarks.test(codePoints[0])) {
    return false;
  }
  for (var _i = 0, _codePoints = codePoints; _i < _codePoints.length; _i++) {
    var ch = _codePoints[_i];
    var _findStatus3 = findStatus(ch.codePointAt(0), {
        useSTD3ASCIIRules: useSTD3ASCIIRules
      }),
      _findStatus4 = _slicedToArray(_findStatus3, 1),
      status = _findStatus4[0];
    if (processingOption === "transitional" && status !== "valid" || processingOption === "nontransitional" && status !== "valid" && status !== "deviation") {
      return false;
    }
  }

  // https://tools.ietf.org/html/rfc5892#appendix-A
  if (checkJoiners) {
    var last = 0;
    var _iterator2 = _createForOfIteratorHelper(codePoints.entries()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
          i = _step2$value[0],
          _ch = _step2$value[1];
        if (_ch === "\u200C" || _ch === "\u200D") {
          if (i > 0) {
            if (regexes.combiningClassVirama.test(codePoints[i - 1])) {
              continue;
            }
            if (_ch === "\u200C") {
              // TODO: make this more efficient
              var next = codePoints.indexOf("\u200C", i + 1);
              var test = next < 0 ? codePoints.slice(last) : codePoints.slice(last, next);
              if (regexes.validZWNJ.test(test.join(""))) {
                last = i + 1;
                continue;
              }
            }
          }
          return false;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  // https://tools.ietf.org/html/rfc5893#section-2
  if (checkBidi) {
    var rtl;

    // 1
    if (regexes.bidiS1LTR.test(codePoints[0])) {
      rtl = false;
    } else if (regexes.bidiS1RTL.test(codePoints[0])) {
      rtl = true;
    } else {
      return false;
    }
    if (rtl) {
      // 2-4
      if (!regexes.bidiS2.test(label) || !regexes.bidiS3.test(label) || regexes.bidiS4EN.test(label) && regexes.bidiS4AN.test(label)) {
        return false;
      }
    } else if (!regexes.bidiS5.test(label) || !regexes.bidiS6.test(label)) {
      // 5-6
      return false;
    }
  }
  return true;
}
function isBidiDomain(labels) {
  var domain = labels.map(function (label) {
    if (label.startsWith("xn--")) {
      try {
        return punycode.decode(label.substring(4));
      } catch (err) {
        return "";
      }
    }
    return label;
  }).join(".");
  return regexes.bidiDomain.test(domain);
}
function processing(domainName, options) {
  var processingOption = options.processingOption;

  // 1. Map.
  var _mapChars = mapChars(domainName, options),
    string = _mapChars.string,
    error = _mapChars.error;

  // 2. Normalize.
  string = string.normalize("NFC");

  // 3. Break.
  var labels = string.split(".");
  var isBidi = isBidiDomain(labels);

  // 4. Convert/Validate.
  var _iterator3 = _createForOfIteratorHelper(labels.entries()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        i = _step3$value[0],
        origLabel = _step3$value[1];
      var label = origLabel;
      var curProcessing = processingOption;
      if (label.startsWith("xn--")) {
        try {
          label = punycode.decode(label.substring(4));
          labels[i] = label;
        } catch (err) {
          error = true;
          continue;
        }
        curProcessing = "nontransitional";
      }

      // No need to validate if we already know there is an error.
      if (error) {
        continue;
      }
      var validation = validateLabel(label, Object.assign({}, options, {
        processingOption: curProcessing,
        checkBidi: options.checkBidi && isBidi
      }));
      if (!validation) {
        error = true;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return {
    string: labels.join("."),
    error: error
  };
}
function toASCII(domainName) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref4$checkHyphens = _ref4.checkHyphens,
    checkHyphens = _ref4$checkHyphens === void 0 ? false : _ref4$checkHyphens,
    _ref4$checkBidi = _ref4.checkBidi,
    checkBidi = _ref4$checkBidi === void 0 ? false : _ref4$checkBidi,
    _ref4$checkJoiners = _ref4.checkJoiners,
    checkJoiners = _ref4$checkJoiners === void 0 ? false : _ref4$checkJoiners,
    _ref4$useSTD3ASCIIRul = _ref4.useSTD3ASCIIRules,
    useSTD3ASCIIRules = _ref4$useSTD3ASCIIRul === void 0 ? false : _ref4$useSTD3ASCIIRul,
    _ref4$processingOptio = _ref4.processingOption,
    processingOption = _ref4$processingOptio === void 0 ? "nontransitional" : _ref4$processingOptio,
    _ref4$verifyDNSLength = _ref4.verifyDNSLength,
    verifyDNSLength = _ref4$verifyDNSLength === void 0 ? false : _ref4$verifyDNSLength;
  if (processingOption !== "transitional" && processingOption !== "nontransitional") {
    throw new RangeError("processingOption must be either transitional or nontransitional");
  }
  var result = processing(domainName, {
    processingOption: processingOption,
    checkHyphens: checkHyphens,
    checkBidi: checkBidi,
    checkJoiners: checkJoiners,
    useSTD3ASCIIRules: useSTD3ASCIIRules
  });
  var labels = result.string.split(".");
  labels = labels.map(function (l) {
    if (containsNonASCII(l)) {
      try {
        return "xn--" + punycode.encode(l);
      } catch (e) {
        result.error = true;
      }
    }
    return l;
  });
  if (verifyDNSLength) {
    var total = labels.join(".").length;
    if (total > 253 || total === 0) {
      result.error = true;
    }
    for (var i = 0; i < labels.length; ++i) {
      if (labels[i].length > 63 || labels[i].length === 0) {
        result.error = true;
        break;
      }
    }
  }
  if (result.error) {
    return null;
  }
  return labels.join(".");
}
function toUnicode(domainName) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref5$checkHyphens = _ref5.checkHyphens,
    checkHyphens = _ref5$checkHyphens === void 0 ? false : _ref5$checkHyphens,
    _ref5$checkBidi = _ref5.checkBidi,
    checkBidi = _ref5$checkBidi === void 0 ? false : _ref5$checkBidi,
    _ref5$checkJoiners = _ref5.checkJoiners,
    checkJoiners = _ref5$checkJoiners === void 0 ? false : _ref5$checkJoiners,
    _ref5$useSTD3ASCIIRul = _ref5.useSTD3ASCIIRules,
    useSTD3ASCIIRules = _ref5$useSTD3ASCIIRul === void 0 ? false : _ref5$useSTD3ASCIIRul;
  var result = processing(domainName, {
    processingOption: "nontransitional",
    checkHyphens: checkHyphens,
    checkBidi: checkBidi,
    checkJoiners: checkJoiners,
    useSTD3ASCIIRules: useSTD3ASCIIRules
  });
  return {
    domain: result.string,
    error: result.error
  };
}
module.exports = {
  toASCII: toASCII,
  toUnicode: toUnicode
};